import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import cn from 'classnames';

import css from 'styles/components/cart/cartErrors.scss';

export class CartErrors extends Component {
  static contextTypes = {
    testId: PropTypes.func,
    marketplace: PropTypes.object
  };

  render() {
    const { testId, marketplace: { cart: { cartName } } } = this.context;
    const {
      cart: { error, cartObj: { savedItems } },
      isModal = false
    } = this.props;

    return (
      (savedItems.length || error) &&
      <div className={cn(css.container, { [css.modal]: isModal })}>
        <p data-test-id={testId('cartError')}>{error}</p>

        { !!savedItems.length &&
          <p data-test-id={testId('oosError')}>An item in your {cartName} is out of stock. It will not show when you proceed to checkout.</p>
        }
      </div>
    );
  }
}

export const mapStateToProps = state => {
  const { cart } = state;

  return {
    cart
  };
};

export default connect(mapStateToProps, {
})(CartErrors);
